import { IFileElementDTOIn } from '../interfaces/file-element.interface';

export const mockCloudRoot: IFileElementDTOIn[] = [
    {
        id: 1,
        name: 'folder 1',
        folders: [],
        items: [],
        employee_ids: [],
        school_class_ids: [],
        group_ids: [],
    },
    {
        id: 2,
        name: 'folder 2',
        folders: [],
        items: [],
        employee_ids: [],
        school_class_ids: [],
        group_ids: [],
    },
    {
        id: 3,
        name: 'folder 3',
        folders: [],
        items: [],
        employee_ids: [],
        school_class_ids: [],
        group_ids: [],
    },
    {
        id: 4,
        name: 'file 4',
        folders: [],
        items: [],
        employee_ids: [],
        school_class_ids: [],
        group_ids: [],
    },
];

export const mockCloud1: IFileElementDTOIn[] = [
    {
        id: 4,
        name: 'folder 4',
        folders: [],
        items: [],
        employee_ids: [],
        school_class_ids: [],
        group_ids: [],
    },
    {
        id: 5,
        name: 'folder 5',
        folders: [],
        items: [],
        employee_ids: [],
        school_class_ids: [],
        group_ids: [],
    },
];
